var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',{staticClass:"admin-container"},[_c('AdminMenu'),_vm._v(" "),_c('el-container',[_c('AdminHeader'),_vm._v(" "),_c('el-main',{staticClass:"admin-main"},[_c('div',{staticClass:"main-content"},[_c('router-view',{ref:"view"})],1)]),_vm._v(" "),_c('AdminFooter',{ref:"footer"})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ceecae2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/index.vue
// module id = null
// module chunks = 